import {
  IsUUID,
  IsString,
  IsEnum,
  IsOptional,
  IsDateString,
  ValidateNested,
} from 'class-validator';
import { Type } from 'class-transformer';

import {
  CompanyResponseInterface,
  CompanyStatus,
} from '../../interface/companies/company-response.interface';

import { MiniUsersDto } from '../users/users.dto';
import { AttachmentsDto } from '../attachments/attachments.dto';
import { Industry, VatType } from '../../utils/enums.utils';

export class CompanyDto implements CompanyResponseInterface {

  @IsUUID()
  id!: string;

  @IsString()
  company_name!: string;

  @IsEnum(Industry)
  industry!: Industry;

  @IsEnum(VatType)
  vat_type!: VatType;

  @IsOptional()
  @IsString()
  product_service!: string | null;

  @IsOptional()
  @IsString()
  payment_terms!: string | null;

  @IsEnum(CompanyStatus)
  status!: CompanyStatus;

  @IsOptional()
  @IsString()
  address!: string | null;

  @IsOptional()
  @IsString()
  tin_number!: string | null;

  @IsString()
  customer_code!: string;

  @IsOptional()
  @IsDateString()
  created_at!: string | null;

  @IsOptional()
  @IsDateString()
  updated_at!: string | null;

  @IsOptional()
  @ValidateNested()
  @Type(() => MiniUsersDto)
  created_by!: MiniUsersDto | null;

  @IsOptional()
  @ValidateNested()
  @Type(() => MiniUsersDto)
  updated_by!: MiniUsersDto | null;

  @IsOptional()
  @ValidateNested()
  @Type(() => AttachmentsDto)
  attachment_company_logo!: AttachmentsDto | null;

  @IsOptional()
  @ValidateNested()
  @Type(() => AttachmentsDto)
  attachment_org_chart!: AttachmentsDto | null;
}